
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function WhiteningConnection() {
  const heading = useFadeIn({ direction: 'up' });
  const body = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-22 md:py-30 px-6 bg-white">
      <div className="max-w-3xl mx-auto space-y-12">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide text-center font-serif">
            歯並びと同時に、<br />
            白さも目指すという選択。
          </h2>
        </div>
        
        <div ref={body.ref} style={body.style}>
          <p className="text-gray-700 text-base md:text-lg font-light leading-loose text-center">
            矯正の「判断軸」を整理したうえで、<br />
            ホワイトニングを検討することもできます。
          </p>
          
          <div className="flex justify-center pt-8">
            <a
              href="#whitening"
              className="text-sm md:text-base text-gray-600 hover:text-gray-900 transition-colors cursor-pointer underline underline-offset-4 decoration-1 whitespace-nowrap"
            >
              ホワイトニングについて
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
